import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type SummaryPricesStylesClasses =
  | 'complexVehicleTitle'
  | 'upperCase'
  | 'boldText'
  | 'bolderText'
  | 'pricesContainer'
  | 'label'
  | 'variantNameText';

const summaryPricesStyles = makeStyles<ISpcTheme>(
  theme => ({
    complexVehicleTitle: {
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1,
      wordBreak: 'break-word',
    },
    label: {
      fontSize: theme.typography.fontMD,
      wordBreak: 'break-word',
    },
    upperCase: {
      textTransform: 'uppercase',
    },
    boldText: {
      fontWeight: theme.typography.fontWeightBold,
    },
    bolderText: {
      fontWeight: 'bolder',
    },
    pricesContainer: {
      paddingTop: '10px',
    },
    variantNameText: {},
  }),
  { name: 'Customise_SummaryPrices' },
);

export default summaryPricesStyles;
